module.exports = __webpack_public_path__ + "img/suit.33dea37f.png";